module.exports = __webpack_public_path__ + "static/media/logodar.39401095.png";